// extracted by mini-css-extract-plugin
export default {"panel":"panel--Rz1Y0","restrictedWidth":"restrictedWidth--NFgSk"};